const STATE_BUILDING_DEPENDENCY_GRAPH = '1_BUILDING_DEPENDENCY_GRAPH'
const STATE_BUILDING_DEPENDENCY_GRAPH_OK = '3_BUILDING_DEPENDENCY_GRAPH_OK'
const STATE_GENERATING_DIAGRAM = '4_GENERATING_DIAGRAM'
const STATE_GENERATING_DIAGRAM_OK = '6_GENERATING_DIAGRAM_OK'
const STATE_GENERATING_CODE_OK = '6_GENERATING_CODE_OK'


export class ArchitectureUtils {
    static isGeneratingArchitecture(architecture) {
        return [
            STATE_BUILDING_DEPENDENCY_GRAPH,
            STATE_BUILDING_DEPENDENCY_GRAPH_OK,
            STATE_GENERATING_DIAGRAM
        ].includes(architecture?.architectureState)
    }

    static hasBuiltDependencyGraph(architecture) {
        return [
            STATE_BUILDING_DEPENDENCY_GRAPH_OK,
            STATE_GENERATING_DIAGRAM,
            STATE_GENERATING_DIAGRAM_OK,
        ].includes(architecture?.architectureState)
    }

    static isGeneratingIaCProject(architecture) {
        return architecture?.IaCState === STATE_BUILDING_DEPENDENCY_GRAPH || architecture?.IaCState === STATE_GENERATING_DIAGRAM
    }

    static hasGeneratedIaCProject(architecture) {
        return architecture?.IaCState === STATE_GENERATING_CODE_OK
    }
}
